import * as React from 'react';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { ColumnType, filterTranslations } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import 'node_modules/video-react/dist/video-react.css';

import * as T from '@modules/events/_eventsTypes';
import { Filter } from 'src/types';
import { getFilters, saveFilters } from '@modules/events/_eventsActions';

type Column = {
  active: boolean;
  field: string;
  label: string;
  type: ColumnType;
  visible: boolean;
  width: number;
};

const enhance = compose<T.EventsFormProps, T.Outter & T.EventsFormProps>(
  withState('loadedFilters', 'setLoadedFilters', [] as Filter[]),
  withState('loading', 'setLoading', true),
  withHandlers({
    applyFilters: ({ loadedFilters, setFilters, closeItem }) => async () => {
      setFilters(loadedFilters);
      closeItem();
    },
    handleSaveFilters: ({ filters, module, closeItem }) => async () => {
      try {
        await saveFilters(module, filters);
      } catch (error) {
        console.error('Error saving filters:', error);
      }

      closeItem();
    }
  }),
  lifecycle<any, any>({
    async componentDidMount() {
      const { setLoadedFilters, setLoading, module } = this.props;

      try {
        const filters = await getFilters(module);

        setLoadedFilters(filters ? JSON.parse(filters.filterSettings) : []);
      } catch (error) {
        console.error('Error loading filters:', error);
        setLoadedFilters([]);
      } finally {
        setLoading(false);
      }
    }
  })
);

const View: React.SFC<
  T.Outter &
    T.EventsFormProps & {
      columns: Column[];
      loadedFilters: Filter[];
      loading: boolean;
      applyFilters: () => void;
      handleSaveFilters: () => void;
    }
> = ({ closeItem, columns, loadedFilters, loading, applyFilters, handleSaveFilters }) => {
  const getColumnLabel = (field?: string | null) => {
    const column = columns.find(col => col.field === field);
    return column ? column.label : field;
  };

  return (
    <div className="layout">
      <div style={{ padding: '16px' }}>
        <p>
          <b>Načtené filtry</b>
        </p>

        {loading ? (
          <div>Načítání filtrů...</div>
        ) : (
          <React.Fragment>
            {loadedFilters.length > 0 ? (
              <ul>
                {loadedFilters.map(({ field, operation, value }, index) => (
                  <li key={index}>
                    {getColumnLabel(field)} - {filterTranslations[operation]} - {value}
                  </li>
                ))}
              </ul>
            ) : (
              <div>Žádné uložené filtry</div>
            )}
          </React.Fragment>
        )}
      </div>

      <Divider />

      <Button
        label="Uložit aktuální filtry"
        onClick={handleSaveFilters}
        primary={true}
        style={{ margin: '16px 0 16px 16px' }}
      />
      <Button
        label="Aplikovat načtené filtry"
        onClick={applyFilters}
        primary={true}
        style={{ margin: '16px 0 16px 16px' }}
      />
      <Button label="Zrušit" onClick={closeItem} style={{ margin: '16px 0 16px 16px' }} />
    </div>
  );
};

export const FiltersMemoryForm = enhance(View);



// WEBPACK FOOTER //
// ./src/components/filtersMemory/FiltersMemoryForm.tsx